import { createFileRoute } from '@tanstack/react-router';
import License from '../../../administration/src/components/Settings/License';

export const Route = createFileRoute('/_secured/administration/account/subscription')({
  component: License,
});
